// extracted by mini-css-extract-plugin
var _1 = "uH7EpjxuKmCElzXX0SrV";
export { _1 as "root" }
